<button mat-button mat-raised-button color="primary-full" (click)="openWidget()" class="click-to-call">
  <i class="material-icons">call</i>
  <span class="m-l-sm" translate>ONBOARDING.MAKE_A_CALL</span>
</button>
